<template>
    <div class="geo-container" style="overflow:hidden">
     <message-bubble :isMine="isMine" :message= message>
       <a class="geo-element" v-if="lon" :href="href" target="_blank" title="点击查看详情">
         <div>
           <span class="text-ellipsis">{{content.name}}</span>
           <span class="text-ellipsis">{{content.address}}</span>
           <span class='text-ellipsis' v-if="content.location_type">{{content.location_type=='cust_self_fuwudian'?'服务店电话:':'经销商电话：'}}{{content.tel}}</span>
         </div>
         <img :src="url" />
       </a>
       <div v-else class="geo-element">
           <div>
           <span class="text-ellipsis">{{content.name}}</span>
           <span class="text-ellipsis">{{content.address}}</span>
           <span class='text-ellipsis' v-if="content.location_type">{{content.location_type=='cust_self_fuwudian'?'服务店电话:':'经销商电话：'}}{{content.tel}}</span>
         </div>
       </div>
     </message-bubble>
     </div>
   </template>
   
   <script>
   import MessageBubble from '../message-bubble'
   export default {
     name: 'GeoElement',
     components:{MessageBubble},
     props: {
       message: {
         type: Object,
         required: true
       },
       isMine: {
         type: Boolean
       }
     },
     data() {
       return {
         url: ''
       }
     },
     computed: {
       lon() {
         return this.content.longitude ? Number(this.content.longitude).toFixed(6) : null
       },
       lat() {
         return this.content.latitude ? Number(this.content.latitude).toFixed(6) : null
       },
       href() {
         return `https://apis.map.qq.com/tools/poimarker?type=0&marker=coord:${this.lat},${this.lon};title:${this.content.name};addr:${this.content.address}&key=EFIBZ-V66WR-UECWI-WVAKH-ENUUE-KBB7W&referer=h5customer`
       },
       content() {
         if(typeof this.message.content == 'string'){
           return JSON.parse(this.message.content)
         }else{
           return this.message.content
         }
       }
     },
     mounted() {
       this.url = `https://apis.map.qq.com/ws/staticmap/v2/?center=${this.lat},${
         this.lon
       }&zoom=10&size=200*100&maptype=roadmap&markers=size:large|color:0xFFCCFF|${
         this.lat
       },${this.lon}&key=EFIBZ-V66WR-UECWI-WVAKH-ENUUE-KBB7W`
     }
   }
   </script>
   
   <style lang="stylus" scoped>
   .geo-container 
     // width: 250px;
     // height: 180px;
     background: #fff;
   .geo-element {
     text-decoration: none;
     background: $white
     display: flex;
     flex-direction: column;
     // padding: 6px;
     div {
       margin: 8px;
       span {
         display: block;
         font-size: 12px;
         color: #aaa
       }
       :first-child {
         font-size: 16px;
         color: $black
       }
     }
     img {
       // margin-top: 12px;
     }
   }
   </style>
   